import apiClient from './client';
import { deliveryStoresApiUrl } from '../utils/runtime';

const API_URL = deliveryStoresApiUrl || '/wp-json/pfandpirat/v1/delivery-stores';

export function buildDeliveryStoresUrl(params = {}) {
  const url = new URL(API_URL, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

export function loadDeliveryStores(params = {}) {
  return apiClient.get(buildDeliveryStoresUrl(params));
}
